export default {
  placeholder: 'Wählen Sie die Tags aus',
  tagPlaceholder: 'Neuen Tag hinzufügen',
};
